/**
 * Browser-ready media URL for <img src>.
 * - Prefixes relative `/api/...` paths with VITE_PUBLIC_API_BASE_URL when set
 *   (production: institution SPA origin may differ from API host).
 */
export function publicMediaSrc(url: string): string {
  const t = typeof url === "string" ? url.trim() : "";
  if (!t) return t;
  if (t.startsWith("/")) {
    const raw = import.meta.env.VITE_PUBLIC_API_BASE_URL as string | undefined;
    const base = raw?.replace(/\/$/, "") ?? "";
    if (base !== "") return `${base}${t}`;
  }
  return t;
}
